
import Constants from './constants';
import {createStore} from 'redux';

const initialState = {
  loading: false,
  success: false,
  captcha: false,
  newsletter: true,
  plan_id: 0,
  // show the basic plan before api results show up
  planOptions: [{
    description: "Free basic access for personal use",
    label: "Basic",
    plan_id: 0,
  }],
  validation: {
    error: undefined,
    hasError: {},
    help: {},
  },
};
const reducer = function (state = initialState, action) {

  if (action.type === Constants.RESET_STORE) {
    return Object.assign({}, initialState);
  }

  if (action.type === Constants.REGISTER) {
    return Object.assign({}, state, action.request.data, {
      loading: true,
      validation: {
        error: undefined,
        hasError: {},
        help: {},
      },
    });
  }

  if (action.type === Constants.REGISTER_RESPONSE) {
    return Object.assign({}, state, {
      success: Boolean(action.error) === false,
      loading: false,
      validation: action.validation,
    });
  }

  if (action.type === Constants.GET_PLAN_OPTIONS_RESPONSE && action.data) {
    return Object.assign({}, state, {
      planOptions: action.data,
    });
  }
  return state;
};


export default createStore(reducer);



// WEBPACK FOOTER //
// ./client/pages/main/signupAccountAPI/store.js